export default __webpack_public_path__ + "static/bell-b0724617f3c452b7fe70d92e9fbced11.png";